<!-- New comment UI: delegate to mtm-video-annotation component -->
@if (enableAnnotationSignal()) {
  <div
    class="media-player annotation-content-preview"
    [style.width]="width"
    resizeObserverElement
    [parentElementContainer]="parentElementContainerSignal()"
    [element]="'.video-js-element-width-track'"
    [enableSizeObserver]="enableResponsiveSignal()"
    [bottomGap]="0"
    [isVideoJs]="true">
    <mtm-video-annotation
      class="w-100 h-100"
      [projectId]="projectIdSignal()"
      [sectionId]="sectionIdSignal()"
      [subsectionId]="subsectionIdSignal()"
      [typeId]="typeIdSignal()"
      [item]="itemSignal()"
      [file]="itemSignal()"
      [projectParticipants]="projectParticipantsSignal()"
      [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
      [annotations]="annotationsSignal()"
      [enableVideoAnnotation]="enableAnnotationSignal()"
      [shareLinkPreview]="isShareLinkPreviewSignal()"
      [portfolioPreview]="portfolioPreviewSignal()"
      [videoPreloadMethod]="videoPreloadMethodSignal()"
      [autoPlayVideo]="autoPlayVideo"
      [width]="width"
      [height]="height"
      [miniPlayer]="miniPlayer"
      [instanceId]="instanceId"
      (videoPlayerLoaded)="onVideoPlayerLoaded()">
    </mtm-video-annotation>
  </div>
}

<!-- Native Video.js container: when annotations are off -->
@if (!enableAnnotationSignal() && mediaTypeSignal() === MediaType.VIDEO && !isErrorSignal()) {
  <div
    class="media-player annotation-content-preview"
    [style.width]="width"
    #videoContainer
    id="videoContainer"
    resizeObserverElement
    [parentElementContainer]="parentElementContainerSignal()"
    [element]="'.video-js-element-width-track'"
    [bottomGap]="0"
    [isVideoJs]="true">
    <div
      class="d-flex align-items-center justify-content-center flex-column position-relative video-player video-js-element-width-track drawing-hidden"
      [class.fullscreen]="isFullscreenSignal()">
      <video
        id="videoJsEl"
        class="video-js m-0 video-js-element-container video-js-element-container--without-comment-bar"
        controls
        #videoPlayer
        [class.release-preview]="isReleasePreviewSignal()"
        [class.share-link-preview]="isShareLinkPreviewSignal()">
      </video>

      <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container>
    </div>
  </div>
}

<!-- Video Error / Processing Container -->
@if (!enableAnnotationSignal() && mediaTypeSignal() === MediaType.VIDEO && !itemSignal()?.metadata) {
  <div
    class="loading-container processing-video-container d-flex align-items-center justify-content-center min-h-250"
    id="loadingVideoContainer"
    #loadingVideoContainer>
    <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
      <span>{{ 'asset_processingFile' | translate }}</span>
      <span>{{ 'asset_pleaseWait' | translate }}</span>
    </div>
  </div>
}

<!-- Loading Container -->
@if (!enableAnnotationSignal() && mediaTypeSignal() === MediaType.VIDEO) {
  <div
    class="loading-container h-100 d-flex hidden-container justify-content-center"
    id="loadingVideoContainerHidden"
    #loadingVideoContainer
    [ngClass]="{ 'min-h-250': !portfolioPreviewSignal() }">
    @if (!portfolioPreviewSignal()) {
      <div class="preview-loading-box d-flex align-items-center justify-content-center flex-column">
        <div class="loading-icon">
          <div class="spinner"></div>
          <img alt="" height="20" width="28" src="../../../../../assets/img/icons/download/process_red.png" />
        </div>
        <span class="heading-text">Please be patient while we load and transcode your video</span>
      </div>
    } @else {
      <div
        class="portfolio-loading-box h-100 w-100 d-flex justify-content-center align-items-center"
        [style.min-height]="previewContainerHeight">
        <div class="spinner"></div>
        <img alt="" height="20" width="28" src="../../../../../assets/img/icons/download/process_red.png" />
      </div>
    }
  </div>
}
